import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CsControlsModule,
  CsDropDownModule,
  CsIconModule,
  CsSnackBarModule
} from '@cbuild/controls';
import {
  FromUTCModule,
  LoadingModule,
  MaskModule,
  PopupActionsModule,
  StyleDisplayModule,
  TimeElapseModule
} from '@cbuild/shared';
import { CallCenterService } from './call-center.service';
import { CallCenterComponent } from './call-center/call-center.component';
import { CallDropPopupComponent } from './call-drop-popup/call-drop-popup.component';
import { CallHistoryComponent } from './call-drop-popup/call-history/call-history.component';
import { CreateNoteComponent } from './call-drop-popup/create-note/create-note.component';
import { CreateSiteVisitComponent } from './call-drop-popup/create-site-visit/create-site-visit.component';
import { CreateTaskComponent } from './call-drop-popup/create-task/create-task.component';
import { LeadActivityComponent } from './call-drop-popup/lead-activity/lead-activity.component';
import { EmailCommunicationComponent } from './call-drop-popup/email-communication/email-communication.component';
import { SmsCommunicationComponent } from './call-drop-popup/sms-communication/sms-communication.component';
import { WhatsappCommunicationComponent } from './call-drop-popup/whatsapp-communication/whatsapp-communication.component';

@NgModule({
  declarations: [
    CallCenterComponent,
    CallDropPopupComponent,
    CreateNoteComponent,
    CreateTaskComponent,
    CreateSiteVisitComponent,
    CallHistoryComponent,
    LeadActivityComponent,
    EmailCommunicationComponent,
    SmsCommunicationComponent,
    WhatsappCommunicationComponent
  ],
  imports: [
    CommonModule,
    CsDropDownModule,
    RouterModule,
    CsIconModule,
    StyleDisplayModule,
    CsSnackBarModule,
    TimeElapseModule,
    CsControlsModule,
    ReactiveFormsModule,
    PopupActionsModule,
    FromUTCModule,
    LoadingModule,
    MaskModule
  ],
  exports: [CallCenterComponent],
  providers: [CallCenterService]
})
export class CallCenterModule {}
